import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material"
import { ModalComponent } from "../../../../components/modal"
import { useState } from "react"
import useAuth from "../../../../context/auth"
import { Format } from "../../../../utils"

interface Props {
    open: boolean,
    onClose: () => void,
    onSelect: (value: "cpf" | "cnpj") => void,
    value?: number,
    isCommission?: boolean
}

export const SelectPIXModal = ({
    onSelect,
    onClose,
    open,
    value,
    isCommission
}: Props) => {
    const { user } = useAuth()
    const [agree, setAgree] = useState(false)
    const [type, setType] = useState<"cpf" | "cnpj" | null>(null)
    return (
        <ModalComponent
            open={open}
            onClose={() => {
                onClose()
                setType(null)
            }}
            title="Sua chave PIX"
            titleProps={{
                fontWeight: "700",
                ml: "2.5%"
            }}
        >
            {isCommission
                ?
                <Typography p={"0rem 2rem"} fontSize={"1.4rem"}>Selecione onde deseja receber sua <strong>comissão{value ? ` de ${Format.currency(value)}` : ""}</strong></Typography>
                :
                <Typography p={"0rem 2rem"} fontSize={"1.4rem"}>Selecione onde deseja receber seu <strong>PIX{value ? ` de ${Format.currency(value)}` : ""}</strong></Typography>}

            <FormControl sx={{
                height: "auto",
                width: "100%",
                padding: "0px 2rem"
            }}>
                <RadioGroup
                    name="radio-buttons-group"
                    value={type}
                    onChange={(e) => setType(e.target.value as any)}
                    sx={{
                        pl: "1rem",
                        gap: "1rem"
                    }}
                >
                    <FormControlLabel sx={{
                        width: "calc(100% - 5rem)",
                        height: "100%",
                        mt: 1,
                        backgroundColor: type === "cnpj" ? "#178BF126" : "#0000000A",
                        padding: "1rem",
                        borderRadius: "10px"
                    }} value={"cnpj"} control={<Radio />} label={
                        <Typography>
                            Chave PIX CNPJ <br />{Format.formatCNPJ(user?.enterprise?.document as string)}
                        </Typography>
                    } />
                    {/* <Typography textAlign={"center"} sx={{ opacity: .5, ml: "-5rem" }}>ou</Typography>
                    <FormControlLabel sx={{
                        width: "calc(100% - 5rem)",
                        height: "100%",
                        backgroundColor: type === "cpf" ? "#178BF126" : "#0000000A",
                        padding: "1rem",
                        borderRadius: "10px"
                    }} value={"cpf"} control={<Radio />} label={
                        <Typography>Chave PIX CPF <br />{Format.formatCPF(user?.cpf as string)}</Typography>
                    } /> */}
                </RadioGroup>
            </FormControl>
            {type &&
                <Typography color="error" p={"2rem 2rem"} textAlign={"justify"} fontStyle={"italic"}><strong>Atenção: </strong>Observe se a chave PIX {type === "cpf" ? "CPF" : "CNPJ"} {type === "cpf" ? Format.formatCPF(user?.cpf as string) : Format.formatCNPJ(user?.enterprise?.document as string)} está devidamente cadastrada na sua conta bancária.</Typography>
            }
            <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
            >
                <Button
                    sx={{
                        height: "4rem",
                        ... (!type && {
                            mt: 2
                        })
                    }}
                    variant="contained"
                    disabled={!type}
                    onClick={() => onSelect(type as any)}
                >Continuar</Button>
            </Grid>
        </ModalComponent>
    )
}